export function removeRegionCode(locale) {
  if (typeof locale !== "string") return locale;
  return locale.split("-")[0];
}
